// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2NY20","buttons":"PendingPaymentAlert_buttons__2BAFb"};